module.exports = __webpack_public_path__ + "img/tooltip-gray-fill.dddb42fc.svg";